import React from "react";

export default function LoadingBlock({ label = "Loading..." }) {
  return (
    <div className="text-muted py-4">
      <div className="d-flex align-items-center gap-2">
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        <span>{label}</span>
      </div>
    </div>
  );
}

